import { Observable, forkJoin, of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { StateObservable } from 'redux-observable'
import { EntityType, NegotiationStatus, Application, NegotiationUpdate, NegotiationSide } from 'api'
import { GlobalState } from 'store'
import { ActivityMonitorActions } from 'store/activityMonitor/activityMonitorActions'
import { getIsUpdatingUserFromDifferentOrganisation, ofEntitySnapshotEndType } from './epicUtils'
import { isToday } from 'utils'
import { NegotiationFilter, createNegotiationEntrySelector } from 'selectors/negotiations'
import { BTQAction } from 'epics'

function isAtStatusForActivity(negotiationUpdate: NegotiationUpdate, state: GlobalState) {
  const isAdmin = state.connectionStore.authorisedUser && state.connectionStore.authorisedUser.application === Application.ADMIN_GATEWAY

  switch (negotiationUpdate.entity.status) {
    case NegotiationStatus.REQUESTED_WITHOUT_PRICE:
    case NegotiationStatus.REQUESTED_WITH_PRICE:
    case NegotiationStatus.CANCELLED:
      return isAdmin || negotiationUpdate.negotiationSide === NegotiationSide.RESPONDER

    case NegotiationStatus.QUOTED:
      return isAdmin || negotiationUpdate.negotiationSide === NegotiationSide.INITIATOR

    case NegotiationStatus.ACCEPTED:
    case NegotiationStatus.REJECTED:
    case NegotiationStatus.WITHDRAWN:
      return getIsUpdatingUserFromDifferentOrganisation(negotiationUpdate.entity.lastUpdatedBy, state)

    default:
      return false
  }
}

function shouldGenerateActivityForNegotiation(negotiationUpdate: NegotiationUpdate, state: GlobalState) {
  if (!negotiationUpdate.entity.sentBackToStaging && isToday(negotiationUpdate.entity.lastUpdatedAt)) {
    return isAtStatusForActivity(negotiationUpdate, state)
  } else {
    return false
  }
}

export function snapshotEpic(
  action$: Observable<BTQAction>,
  state$: StateObservable<GlobalState>,
  _dependencies: {}
): Observable<BTQAction> {
  return forkJoin(
    action$.pipe(ofEntitySnapshotEndType(EntityType.USER)),
    action$.pipe(ofEntitySnapshotEndType(EntityType.TRADING_ENTITY)),
    action$.pipe(ofEntitySnapshotEndType(EntityType.NEGOTIATION))
  ).pipe(
    mergeMap(() => {
      const repositoryEntries = [
        ...createNegotiationEntrySelector({ negotiationFilter: NegotiationFilter.InitiatorOnly })(state$.value),
        ...createNegotiationEntrySelector({ negotiationFilter: NegotiationFilter.ResponderOnly })(state$.value)
      ]
      const megotiationUpdates = Object.values(repositoryEntries)
        .map(negotiationEntry => negotiationEntry.lastUpdate)
        .filter(negotiationUpdate => shouldGenerateActivityForNegotiation(negotiationUpdate, state$.value))

      const createActivityActions = megotiationUpdates.map(negotiationUpdate =>
        ActivityMonitorActions.createActivity({ negotiationUpdate })
      )

      return of(...createActivityActions)
    })
  )
}
